import { render, staticRenderFns } from "./TidyingView.vue?vue&type=template&id=033e600e"
import script from "./TidyingView.vue?vue&type=script&lang=js"
export * from "./TidyingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports